import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  details: [
    {
      date: '04',  // Only the day part for consistency with URL
      totalDuration: '8h 28m',
      clockInTime: '10:15 am',
      clockOutTime: '06:43 pm',
      site: 'ng office',
      paycode: 'Regular',
      jobCode: '--',
      department: 'ACCOUNTS',
      shift: '24 hours',
      break: '02:14 PM - 03:09 PM (0h 55m)',
    },
    {
      date: '05',
      totalDuration: '7h 55m',
      clockInTime: '09:00 am',
      clockOutTime: '04:55 pm',
      site: 'ng office',
      paycode: 'Regular',
      jobCode: '1234',
      department: 'HR',
      shift: 'Day Shift',
      break: '01:00 PM - 01:45 PM (0h 45m)',
    },
    // Add more details for other dates here
  ],
};

const timecardDetailSlice = createSlice({
  name: 'timecardDetail',
  initialState,
  reducers: {},
});

export default timecardDetailSlice.reducer;

